export const stepsRoutes = {
  START: 'inicio',
  CPF: 'cpf',
  ACTIVATION_PENDING: 'pendente-de-ativacao',
  NAME: 'nome',
  BIRTHDATE: 'data-de-nascimento',
  CONTACT_DETAILS: 'dados-de-contato',
  CHOOSE_VALIDATION: 'forma-de-validacao',
  CODE_VALIDATION_SMS: 'validacao-sms',
  CODE_VALIDATION_MAIL: 'validacao-email',
  CHOOSE_HEALTH_PLAN: 'possui-plano',
  HEALTH_PLAN: 'selecionar-plano',
  OTHER_HEALTH_PLAN: 'outros-planos',
  CARD_NUMBER: 'numero-da-carterinha',
  HOLDER_OR_DEPENTENT: 'titularidade',
  VALIDATE_USER_DATA: 'confirmacao-dos-dados',
  CREATE_PASSWORD: 'criar-senha',
  CREATED_ACCOUNT_SUCCESS: 'conta-criada',
  CREATE_ACCOUNT_ERROR: 'problema-criacao-conta',
}
